export const initialState = {};

export const isModalOpen = (state = initialState, name) => !!state[name];
